





































































import Vue, { PropType } from "vue";
import status from "@/utils/status";

interface databaseBackup {
    databaseName: string,
    backupStartDate: Date,
    backupFinishDate: Date,
    backupType: number,
    backupSize: bigint,
    status: number,
    backupFrequency: number
}

export default Vue.extend({
    name: "sql-database-backup-list",
    props: {
        databaseBackups: {
            type: Array as PropType<Array<databaseBackup>>,
            required: false
        }
    },
    methods: {
        statusIcon: function (db: databaseBackup) {
            return status.getStatusIcon(db.status);
        },
        statusColor: function (db: databaseBackup) {
            return status.getStatusColorName(db.status);
        },
        backupTypeStr: function (type: number) {
            switch (String.fromCharCode(type)) {
                case 'D':
                case 'F':
                    return 'Full';
                case 'I':
                case 'G':
                    return 'Diff';
                case 'L':
                    return 'Log';
                case 'P':
                case 'Q':
                    return 'Partial';
                default:
                    return 'Unknown';
            }
        }
    }
});
